import { html } from '@beunity/lit-components';
import DotMenu from '@beunity/lit-components/components/dot_menu/element.js';
import DotMenu2 from '@beunity/lit-components/components/dot_menu_2/element.js';

DotMenu.prototype.renderTrigger = function renderTrigger() {
  return html`
    <button class=${this.buttonClass || 'bu-btn btn-contrast-light'}>
      <bu-icon name="ellipsis-vertical"></bu-icon>
    </button>
  `;
};

DotMenu.prototype.renderButton = function renderButton(item) {
  return html`
    <button
      @click=${() => this.generateBrowserAction(item.action)}
      class="item-with-icon">
      <bu-icon-block
        text=${item.title}
        icon=${item.icon}
        part=${item.partName ? `icon-block ${item.partName}` : 'icon-block'}>
      </bu-icon-block>
    </button>
  `;
};

DotMenu.prototype.createIonicIconElement = function createIonicIconElement() {
  return document.createElement('bu-icon');
};

DotMenu2.prototype.renderTrigger = function renderTrigger() {
  return html`
    <button class=${this.buttonClass || 'bu-btn btn-contrast-light'}>
      <bu-icon name="ellipsis-vertical"></bu-icon>
    </button>
  `;
};
